
export default {
  name: 'svg-wrapper',
}
